import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bzxg32q5dk: FaireBrandEntity = {
  token: "b_bzxg32q5dk",
  type: "brand",
  name: "Alta Gama Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/ff62b7b336cc8a758e7c9c2316c3811ae3c9a75d9a0bc6135e72eac83f0e3738.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b7e4779e7c7de89d5916ea352e6aa8dd04cad48eaeaa264f0d4f4e98e4cd7e33.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ff62b7b336cc8a758e7c9c2316c3811ae3c9a75d9a0bc6135e72eac83f0e3738.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b7e4779e7c7de89d5916ea352e6aa8dd04cad48eaeaa264f0d4f4e98e4cd7e33.png",
  location: "Kyle, TX, USA",
  minimumOrderDollars: 173,
  rating: 4.4,
  reviewCount: 26,
  isInsider: true,
  description:
    "Alta Gama, known as High Quality, was born from wanting to experience the true and traditional flavors from Spain we had tasted all of our lives. My grandfather, originally from Madrid, always said how Spain had the best food in the world, but few people knew about it. Alta Gama’s mission is to connect top producers of quality, gourmet foods with customers that are searching for unique and authentic products. \nWe currently work with our family, located in Madrid, to select and build relationships with top producers bringing trust and reliability. Our family, having been in the hospitality business for years, hand-select each product that we offer. Our goal is to find family producers with traditional techniques yet to be discovered in the international mainstream market, and only selecting those that stand out for their quality and tradition.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:20.750Z",
    importedBy: "entity-db-cli",
  },
};
